import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

/**
 * 页面骨架屏组件
 * 用于提升加载时的视觉体验
 */

export const PageSkeleton: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-white dark:bg-slate-950">
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.5 }}
      transition={{ duration: 0.3 }}
      className="flex flex-col items-center gap-4"
    >
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
      >
        <Loader2 size={48} className="text-[#c99c2e]" />
      </motion.div>
      <p className="text-slate-500 dark:text-slate-400 font-medium animate-pulse">
        加载中...
      </p>
    </motion.div>
  </div>
);
